import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { TypeEntreprise } from 'src/app/shared/models/typeEntreprise';

@Component({
	selector: 'app-typeEntreprise-modal-detail',
	templateUrl: './typeEntreprise-modal-detail.component.html',
	styleUrls: ['./typeEntreprise-modal-detail.component.scss']
})
export class TypeEntrepriseModalDetailComponent implements OnInit {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		name: new FormControl('', [
			Validators.required
		])
	});

	typeEntreprise: TypeEntreprise;

	confirmDeleteModalRef: BsModalRef;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private modalService: BsModalService
	) {}

	ngOnInit(): void {
		this.formEdit.setValue({
			name: this.typeEntreprise ? this.typeEntreprise.name : null
		});
	}

	onSubmit() {
		this.isValidateButtonClicked = true;
		this.typeEntreprise.name = this.formEdit.get('name').value;
		this.facade.typeEntrepriseService.updateTypeEntreprise(this.typeEntreprise).subscribe({
			next: (succ) => {
				// this.isValidateButtonClicked=false;
				this.bsModalRef.hide();
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
			}
		});
	}

	deleteSpecialty(): void {
		this.facade.typeEntrepriseService
			.deleteTypeEntreprise(this.typeEntreprise.id)
			.subscribe((_) => {
				this.modalService.hide();
				this.bsModalRef.hide();
			});
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	delete() {
		this.facade.typeEntrepriseService
			.deleteTypeEntreprise(this.typeEntreprise.id)
			.subscribe({
				next: (succ) => {
					this.modalService.hide();
					this.bsModalRef.hide();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
				}
			});
	}

	get name() {
		return this.formEdit.get('name');
	}
}
